import Vue from 'vue'
import OpenStreetMapAPI from '../api/OpenStreetMapAPI';

Vue.use({
  install(vue, options) {
    vue.prototype.$OpenStreetMapAPI = vue.$OpenStreetMapAPI = new OpenStreetMapAPI(vue);
  }
}, undefined);